import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import {
  StrapiContactFormSectionDTO,
  ContactFormSectionDTO,
} from "@lib/strapi/dtos/components/sections/contactFormSection.dto";
import { parseStrapiContent } from "@lib/strapi/content";

export class ContactFormSectionService {
  static async fromStrapi(
    locale: string,
    strapiData?: StrapiContactFormSectionDTO,
  ): Promise<ContactFormSectionDTO> {
    if (!strapiData) {
      return null;
    }
    const dto = new ContactFormSectionDTO();
    Object.assign(
      dto,
      await DynamicZoneComponentDTO.fromStrapi(locale, strapiData),
    );
    dto.heading = strapiData.heading;
    dto.intro = await parseStrapiContent(strapiData.intro);
    dto.successMessage = await parseStrapiContent(strapiData.successMessage);
    return dto;
  }
}
